import { getDb } from '../db/database';

/**
 * Uygulamayı ilk kurulum hâline döndürme.
 *
 * NEDEN AYRI DOSYA: Bu fonksiyon eskiden `demoData.ts` içindeydi; o
 * modül yalnızca geliştirme sırasında yüklenir ve sahte geçmiş üreten
 * kodu taşır. Sıfırlama artık ÜRETİMDE de kullanılabildiği için orada
 * kalamazdı — `demoData`'yı üretimde import etmek, sahte veri
 * üretecini de kullanıcının paketine sokardı.
 */

/**
 * Her şeyi siler ve uygulamayı ilk kurulum hâline döndürür.
 *
 * Veritabanını komple siliyoruz; `startApp` açılışta alışkanlıkları ve
 * temizlik odalarını yeniden tohumluyor. Tek tek store temizlemekten
 * daha güvenli — ileride eklenen bir store'u unutma ihtimali kalmıyor.
 *
 * DİKKAT: geri alınamaz ve yedeği yoktur. Çağırmadan önce kullanıcıdan
 * açık onay alınmalı (bkz. `pages/profile.ts`, iki aşamalı onay).
 */
export async function wipeAllData(): Promise<void> {
  const db = await getDb();
  // Bağlantı açıkken silme işlemi "blocked" durumunda takılır.
  db.close();

  await new Promise<void>((resolve, reject) => {
    const request = indexedDB.deleteDatabase('discipline');
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
    // Başka bir sekme açıksa engellenebilir; yine de devam ediyoruz ki
    // arayüz kilitlenmesin.
    request.onblocked = () => resolve();
  });
}
